import Logo from "src/components/common/LogoSign";
import {
	Box,
	Container,
	Button,
	CircularProgress,
	Divider,
	Drawer,
	IconButton,
	Tooltip,
	Collapse,
	styled,
	useTheme,
	FormControl,
	Input,
	alpha,
} from "@mui/material";
import { logout } from "src/services/auth.service";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";
import { NavbarContext } from "src/contexts/NavbarContext";
import { isLoggedIn, isParentLoggedIn } from "src/services/auth.service";
import { isTester } from "src/models/User";
import { useContext, useState, useEffect } from "react";
import Link from "src/components/common/Link";
import { useLocation } from "react-router";
import { getMainProgramCategories } from "src/services/category";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboaddArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useNavigate } from "react-router";
import getParent from "src/models/Parent";
import { useDispatch, useSelector } from "react-redux";
import { setSearch } from "src/features/home/program/programSlice";
import Cancel from "@mui/icons-material/Cancel";

const NavbarWrapper = styled(Box)(
	({ theme }) => `
		top: 0;
		left: 0;
		right: 0;
		z-index: 99;
		background-color: ${theme.colors.alpha.trueWhite[100]};
`
);

const ButtonRounded = styled(Button)(
	() => `
    border-radius: 50px;
    padding: 8px 25px;
    font-weight: bold;
`
);

const ButtonList = styled(Button)(
	({ theme }) => `
	width: 100%;
	min-height: 44px;
	justify-content: flex-start;
	padding: 10px 12px;
	border-radius: 12px;
	font-weight: 600;
	text-transform: none;
	color: ${theme.colors.primary.main};
	&:hover {
		background-color: ${theme.colors.primary.lighter};
		color: ${theme.colors.primary.main};
	}
`
);

const CustomDrawer = styled(Drawer)(
	() => `
		.MuiDrawer-paper {
			position: initial;
		}
`
);

const NavbarMobile = ({ position }) => {
	const { navbarToggle, toggleNavbar } = useContext(NavbarContext);
	const closeNavbar = () => {
		setOpen(false);
		toggleNavbar();
	};
	const theme = useTheme();
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch()
	const [open, setOpen] = useState(false);
	const [openGroup, setOpenGroup] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	// const [search, setSearch] = useState("");
	const [openCategory, setOpenCategory] = useState([]);
	const [mainProgramCategories, setMainProgramCategories] = useState([]);
	const { search } = useSelector((state: any) => state.programSlice);
	const [searchValue, setSearchValue] = useState(search)

	useEffect(() => {
		getMainProgramCategories().then((res) => {
			setMainProgramCategories(res.data.data);
			setOpenCategory(res.data.data.map((category) => false));
		});
	}, []);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setOpen(!open);
	};

	const handleClickCategory = (slug) => {
		navigate(
			`/programs/${slug}`
		);
		closeNavbar();
	};

	const handleClickMenu = (path) => {
		closeNavbar();
		navigate(path);
	}

	const newsAndJobs = [
		{ to: "/blogs", label: "Article" },
		{ to: "/jobs", label: "Jobs" },
	];

	// Tes Love Language selalu paling bawah
	const tools = [
		{ to: "/cv-builder", label: "CV Builder" },
		{ to: "/skd-readiness", label: "SKD Readiness" },
		{ to: "/interview-readiness", label: "Interview Readiness" },
		{ to: "/tes-kepribadian", label: "Tes Kepribadian" },
		{ to: "/tes-love-language", label: "Tes Love Language" },
	];

	const pathIsActive = (pathname, to) => {
		if (to === "/blogs") {
			return pathname === "/blogs" || pathname.startsWith("/blog/");
		}
		return pathname === to || pathname.startsWith(`${to}/`);
	};

	const rowSx = (isActive, { nested = false } = {}) => {
		const primary = theme.colors.primary.main;
		// Parent selected: solid primary. Child selected: primary transparan.
		const activeBg = nested ? alpha(primary, 0.16) : primary;
		const activeColor = nested
			? primary
			: theme.colors.alpha.trueWhite[100];

		return {
			width: "100%",
			justifyContent: "flex-start",
			fontWeight: isActive ? 700 : nested ? 500 : 600,
			fontSize: nested ? "0.9rem" : undefined,
			color: isActive ? activeColor : primary,
			backgroundColor: isActive ? activeBg : "transparent",
			"&:hover": {
				backgroundColor: isActive ? activeBg : theme.colors.primary.lighter,
				color: isActive ? activeColor : primary,
			},
		};
	};

	const nestedMenuSx = {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		mt: 1.25,
		pt: 1,
		pl: 1.5,
		ml: 0.75,
		borderLeft: `2px solid ${theme.colors.primary.lighter}`,
		gap: 0.5,
	};

	const renderNavGroup = (id, label, items) => {
		const isOpen = openGroup === id;
		const isActive = items.some((item) => pathIsActive(location.pathname, item.to));

		return (
			<Box key={id}>
				<ButtonList
					id={`${id}-button`}
					aria-controls={`${id}-menu`}
					aria-haspopup="true"
					aria-expanded={isOpen ? "true" : undefined}
					onClick={() => setOpenGroup(isOpen ? null : id)}
					endIcon={isOpen ? <KeyboaddArrowUpIcon /> : <KeyboardArrowDownIcon />}
					variant="text"
					sx={{
						...rowSx(isActive),
						justifyContent: "space-between",
					}}>
					{label}
				</ButtonList>
				<Collapse in={isOpen} timeout="auto" unmountOnExit>
					<Box id={`${id}-menu`} sx={nestedMenuSx}>
						{items.map((item) => {
							const itemActive = pathIsActive(location.pathname, item.to);
							return (
								<ButtonList
									key={item.to}
									variant="text"
									color="primary"
									onClick={() => handleClickMenu(item.to)}
									sx={rowSx(itemActive, { nested: true })}>
									{item.label}
								</ButtonList>
							);
						})}
					</Box>
				</Collapse>
			</Box>
		);
	};

	const NavButton = ({ to, label, location }) => {
		const isActive =
			(to.includes("/programs") && location.pathname.startsWith("/programs")) ||
			location.pathname === to;

		return (
			<ButtonList
				variant="text"
				color="primary"
				fullWidth
				onClick={() => handleClickMenu(to)}
				sx={rowSx(isActive)}>
				{label}
			</ButtonList>
		);
	};

	useEffect(() => {
		// Reset search state saat navbar pertama kali mount
		dispatch(setSearch({ search: "" }))
	}, [dispatch])

	useEffect(() => {
		// Clear search ketika user keluar dari halaman programs
		// Tujuannya: saat balik ke /programs, list kembali tampil semua
		const isProgramsPage = location.pathname.startsWith("/programs");

		if (!isProgramsPage && search !== "") {
			dispatch(setSearch({ search: "" }));
			setSearchValue("");
		}
	}, [location.pathname, search, dispatch])

	useEffect(() => {
		// Sync local input value with Redux search
		// Tujuan: kalau search berubah dari halaman Programs / clear button / navbar lain, input navbar mobile ikut update
		setSearchValue(search ?? "");
	}, [search]);

	return (
		<>
			<NavbarWrapper
				sx={{
					px: 1,
					py: 1.4,
					background: "transparent",
					position: position,
				}}>
				{/* Mobile View */}
				<Container maxWidth="lg" sx={{ px: 1 }}>
					<Box
						display="flex"
						justifyContent="space-between"
						py={0.5}
						style={{
							borderRadius: "28px",
							border: "1px solid #eee",
							boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
							backgroundColor: `${theme.colors.alpha.trueWhite[100]}`,
							opacity: 0.9,
						}}
						alignItems="center">
						<Box sx={{ ml: -0.8, mb: 0.6 }}>
							<Logo scale={0.7} />
						</Box>
						<Tooltip arrow title="Lihat Menu">
							<Box style={{ marginTop: 1.4 }}>
								<IconButton color="primary" onClick={closeNavbar} role="button">
									{!navbarToggle ? (
										<img src={`${process.env.REACT_APP_IMAGE_URL}static/images/icons/hamburger.svg`} alt="menu" />
									) : (
										<CloseTwoToneIcon fontSize="small" />
									)}
								</IconButton>
							</Box>
						</Tooltip>
					</Box>
				</Container>
			</NavbarWrapper>
			<CustomDrawer
				sx={{
					boxShadow: `${theme.sidebar.boxShadow}`,
				}}
				anchor="left"
				open={navbarToggle}
				onClose={closeNavbar}
				variant="temporary"
				elevation={0}>
				<NavbarWrapper
					sx={{
						borderBottom: "1px solid #D9DBE9",
					}}>
					<Container maxWidth="lg">
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								pb: 2,
							}}>
							<Box
								display="flex"
								justifyContent="space-between"
								py={2}
								sx={{
									width: "100%",
								}}
								alignItems="center">
								<Box sx={{ ml: -2 }}>
									<Logo scale={0.7} />
								</Box>
								<Tooltip arrow title="Lihat Menu">
									<IconButton color="primary" onClick={closeNavbar} role="button">
										{!navbarToggle ? (
											<MenuTwoToneIcon fontSize="small" />
										) : (
											<CloseTwoToneIcon fontSize="small" />
										)}
									</IconButton>
								</Tooltip>
							</Box>
							<Divider
								sx={{
									mt: theme.spacing(1),
									mx: theme.spacing(2),
									background: theme.colors.alpha.trueWhite[10],
								}}
							/>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 0.5,
									width: "100%",
								}}>
								<NavButton
									to="/"
									label="Home"
									location={location}
								/>
								{!isTester() && (
									<>
										<ButtonList
											id="basic-button"
											aria-controls="basic-menu"
											aria-haspopup="true"
											aria-expanded={open ? "true" : undefined}
											onClick={handleClick}
											endIcon={
												open ? <KeyboaddArrowUpIcon /> : <KeyboardArrowDownIcon />
											}
											variant="text"
											sx={{
												...rowSx(location.pathname.startsWith("/programs")),
												justifyContent: "space-between",
											}}>
											Programs
										</ButtonList>
										<Collapse in={open} timeout="auto" unmountOnExit>
											<Box sx={nestedMenuSx}>
												{mainProgramCategories.map((category, index) => (
													<Box
														key={category.id}
														sx={{
															display: "flex",
															flexDirection: "column",
															width: "100%",
														}}>
														<ButtonList
															variant="text"
															color="primary"
															endIcon={
																openCategory[index] ? (
																	<KeyboaddArrowUpIcon />
																) : (
																	<KeyboardArrowDownIcon />
																)
															}
															onClick={() => {
																let temp = [...openCategory];
																temp = temp.map((item, i) => {
																	if (i === index) {
																		return !item;
																	} else {
																		return false;
																	}
																});
																setOpenCategory(temp);
															}}
															sx={{
																justifyContent: "space-between",
																backgroundColor: openCategory[index]
																	? theme.colors.primary.lighter
																	: "transparent",
															}}>
															{category.name}
														</ButtonList>
														{category.children.map((category, index2) => (
															<Collapse
																in={openCategory[index]}
																timeout="auto"
																key={category.id}
																unmountOnExit>
																<Box
																	key={category.id}
																	sx={{
																		display: "flex",
																		flexDirection: "column",
																		alignItems: "left",
																		width: "100%",
																	}}>
																	<ButtonList
																		variant="text"
																		color="primary"
																		sx={{ pl: 3 }}
																		onClick={() =>
																			handleClickCategory(category.slug)
																		}>
																		- {category.name}
																	</ButtonList>
																</Box>
															</Collapse>
														))}
													</Box>
												))}
											</Box>
										</Collapse>
									</>
								)}
								<NavButton
									to="/testimony"
									label="Testimonies"
									location={location}
								/>
								{renderNavGroup("news-jobs", "Article & Jobs", newsAndJobs)}
								{renderNavGroup("tools", "Tools", tools)}
								<a
									href="#footer"
									onClick={closeNavbar}
									style={{ width: "100%" }}>
									<ButtonList variant="text" color="primary">
										Contact
									</ButtonList>
								</a>
								{isParentLoggedIn() && getParent() && (
									<NavButton
										to={`/report/member/${getParent().token}`}
										label="Report"
										location={location}
									/>
								)}
							</Box>

							{/* Always show search bar (including on /programs) */}
							{!isTester() && (
								<FormControl sx={{ mt: 1, mb: 2, width: "100%" }}>
									<Input
										placeholder="Cari Program"
										sx={{ mt: 0 }}
										startAdornment={
											<img
												src={`${process.env.REACT_APP_IMAGE_URL}static/images/placeholders/icons/search.svg`}
												alt="icon search"
												style={{ marginRight: "10px" }}
											/>
										}
										// Clear search and show all programs again
										endAdornment={
											(searchValue ?? "").trim() !== "" ? (
												<Cancel
													sx={{ cursor: "pointer" }}
													onClick={() => {
														setSearchValue("");
														dispatch(setSearch({ search: "" }));
														navigate("/programs");
													}}
												/>
											) : null
										}
										value={searchValue}
										onChange={(e) => {
											setSearchValue(e.target.value);
										}}
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												e.preventDefault();

												// Dispatch dulu supaya /programs mount dengan keyword yang benar (langsung terfilter)
												const keyword = (searchValue ?? "").trim();
												dispatch(setSearch({ search: keyword }));
												navigate(`/programs`);
												closeNavbar();
											}
										}}
									/>
								</FormControl>
							)}

							<Divider variant="middle" />
							{isLoggedIn() ? (
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										borderTop: "1px solid #D9DBE9",
										width: "100%",
										pt: 2,
									}}>
									<ButtonRounded
										variant="text"
										color="primary"
										onClick={closeNavbar}
										startIcon={<AccountTreeTwoToneIcon />}
										sx={{ mb: 1 }}>
										<Link to="/dashboards">E-Learning</Link>
									</ButtonRounded>
									<ButtonRounded
										variant="contained"
										color="primary"
										disabled={isLoading}
										onClick={async () => {
											setIsLoading(true);
											closeNavbar();
											if (!(await logout())) setIsLoading(false);
										}}>
										{isLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Logout'}
									</ButtonRounded>
								</Box>
							) : (
								<Box display="flex" alignItems="center">
									<Link to="/login" onClick={closeNavbar}>
										<ButtonRounded
											variant="outlined"
											color="primary"
											sx={{ mr: 1 }}>
											Login
										</ButtonRounded>
									</Link>
									<Link to="/auth/register" onClick={closeNavbar}>
										<ButtonRounded variant="contained" color="primary">
											Register
										</ButtonRounded>
									</Link>
								</Box>
							)}
						</Box>
					</Container>
				</NavbarWrapper>
			</CustomDrawer>
		</>
	);
};

export default NavbarMobile;
